import PriceDetailsRenderer from '../shared/PriceDetails';
import type DetailPriceList from '../../../assets/js/modules/listing/components/detail-price-list/DetailPriceList';
import Sentry from '../../components/sentry';

async function init(): Promise<void> {
    Sentry.getInstance();

    const priceListName = 'nh-detail-price-list';
    const detailPriceList = document.querySelector(priceListName) as DetailPriceList;

    const mountElement = document.querySelector('[data-react-id="price-details"]') as HTMLElement;
    if (!mountElement || !detailPriceList) return;

    const priceDetailsRenderer = new PriceDetailsRenderer({
        mountElement,
        showDeposit: false,
        showPayUponArrivalAsterisk: false
    });

    await customElements.whenDefined(priceListName);
    detailPriceList.attach(priceDetailsRenderer);
}

init();
